var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",staticStyle:{"max-width":"120px"},attrs:{"items":_vm.allowedYears,"label":"Año","dense":"","outlined":"","hide-details":""},on:{"change":_vm.onYearChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }